import { useEffect, useState } from "react"
import { FiPlus } from "react-icons/fi"
import InventorForm from "./InventorForm"
import SavedInventorBox from "./SavedInventorBox"
import { useResetListener } from "../../hooks/useResetListener"

export default function AddInventorBox({
  onChange,
  initialData,
  disabled = false
}: {
  onChange?: (list: any[]) => void
  initialData?: any[] | null
  disabled?: boolean
}) {
  const [inventors, setInventors] = useState<any[]>(initialData || [])
  const [isFormOpen, setIsFormOpen] = useState(false)
  const [editingIndex, setEditingIndex] = useState<number | null>(null)

  useEffect(() => {
    if (initialData) {
      setInventors(initialData)
    }
  }, [initialData])

  useResetListener(() => {
    setInventors([])
    setEditingIndex(null)
    setIsFormOpen(false)
    onChange?.([])
  })

  const handleSave = (formData: any) => {
    setInventors((prev) => {
      const updated =
        editingIndex !== null
          ? prev.map((inventor, index) =>
              index === editingIndex ? formData : inventor
            )
          : [...prev, formData]

      onChange?.(updated)
      return updated
    })

    setIsFormOpen(false)
    setEditingIndex(null)
  }

  const handleDelete = (index: number) => {
    setInventors((prev) => {
      const updated = prev.filter((_, i) => i !== index)
      onChange?.(updated)
      return updated
    })
  }

  return (
    <div className="flex flex-col gap-6">
      {inventors.length > 0 && (
        <div className="flex flex-col gap-3">
          {inventors.map((inventor, index) => (
            <SavedInventorBox
              key={index}
              inventor={inventor}
              onEdit={() => {
                if (disabled) return
                setEditingIndex(index)
                setIsFormOpen(true)
              }}
              onDelete={() => {
                if (!disabled) handleDelete(index)
              }}
            />
          ))}
        </div>
      )}

      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            setEditingIndex(null)
            setIsFormOpen(true)
          }
        }}
        className="flex w-full flex-col items-center justify-center rounded-xl border-[1.5px] border-dashed border-gray-300 bg-gray-50/60 p-5 text-dantzBlue transition-colors hover:border-dantzBlue hover:bg-blue-50/50 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <FiPlus size={20} />
        <span className="mt-1 text-sm font-medium">Add Inventor</span>
        <span className="mt-0.5 text-[11px] text-gray-400">
          Name and address, or waiver of the right to be mentioned
        </span>
      </button>

      {isFormOpen && (
        <div className="border border-gray-200 rounded-2xl bg-white p-6 shadow-sm max-w-full space-y-6">
          <InventorForm
            onCancel={() => setIsFormOpen(false)}
            onSave={handleSave}
            initialValues={editingIndex !== null ? inventors[editingIndex] : undefined}
          />
        </div>
      )}
    </div>
  )
}
